import './phone-accepting-actions.ajscss';

import { IPhoneActionsService } from '@agent/agent-interface/contact-view/phone/phone-actions.service';
import { IAgentConfigDeprecatedService } from '@agent/core/agent/agent-config-deprecated.service';
import { AppointmentQualificationStatus, IAppointmentDeprecatedService } from '@agent/core/contact/appointment-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { Appointment } from '@commons/models/appointment';
import { PostContactReportDto } from '@commons/models/post-contact-report';
import { IComponentController, IComponentOptions, ILogService } from 'angular';

import { DisplayDeprecatedComponent, Option, QualifField } from '@contact/upgrade';

import templateUrl from './phone-accepting-actions.template.html';

export class PhoneAcceptingActionsCtrl extends DisplayDeprecatedComponent implements IComponentController {
  responseId: string;
  canRefuse: boolean = false;
  canCancel = false;
  fields: QualifField[];
  campagneId: string;
  // params
  currentAppointment: Appointment;
  selectedStatus: AppointmentQualificationStatus = AppointmentQualificationStatus.CANCELED;

  constructor(
    protected $log: ILogService,
    protected contactDeprecatedService: IContactDeprecatedService,
    protected phoneActions: IPhoneActionsService,
    protected agentConfigDeprecatedService: IAgentConfigDeprecatedService,
    protected sessionDeprecatedService: SessionDeprecatedService,
    protected appointmentDeprecatedService: IAppointmentDeprecatedService
  ) {
    super();
  }

  $onInit(): void {
    this.contactDeprecatedService
      .getContact(this.responseId)
      .then(
        // The CSR can refuse if the configuration  or the campaign allow him to do so (for resp. incoming/outgoing calls)
        contact => {
          this.canRefuse =
            Option.of(contact.campaign)
              .map(campaign => campaign.campaign.csrCanRefuseCall)
              .getOrElse(false) || this.agentConfigDeprecatedService.canRefuseContact(contact.channel);
          this.campagneId = Option.of(contact.campaign)
            .map(campaign => campaign.campaign.id)
            .getOrElse('');
        },
        err => this.errorCallback(err)
      )
      .then(() => {
        this.appointmentDeprecatedService.getCampaignById(this.campagneId).then(success => {
          this.canCancel = success.data.csrCanCancel;
        });
      });
  }

  accept(): void {
    this.contactDeprecatedService.getContact(this.responseId).then(
      contact => this.phoneActions.accept(contact),
      err => this.errorCallback(err)
    );
  }

  refuse(): void {
    this.contactDeprecatedService.getContact(this.responseId).then(
      contact => this.phoneActions.refuse(contact),
      err => this.errorCallback(err)
    );
  }

  cancel(): void {
    this.fields = [];
    this.contactDeprecatedService.getContact(this.responseId).then(
      contact => {
        this.currentAppointment = new Appointment();
        this.currentAppointment.idContact = contact.campaign?.campaignContactId !== undefined ? contact.campaign?.campaignContactId : '';
        this.currentAppointment.phone = contact.phoneNumber !== undefined ? contact.phoneNumber : ' ';
        this.currentAppointment.campaign = contact.campaign?.campaign!;
        this.contactDeprecatedService.cancelCampaign(this.responseId).then(() => {
          this.contactDeprecatedService.hangUp(this.responseId).then(() => {
            this.appointmentDeprecatedService
              .closeAppointment(
                PostContactReportDto.toDto(
                  this.selectedStatus,
                  this.currentAppointment,
                  this.fields,
                  this.sessionDeprecatedService.getProfile().id,
                  this.sessionDeprecatedService.getProfile().login,
                  contact.skills,
                  'CANCEL_DURING_ASSIGN',
                  'CANCEL'
                )
              )
              .then(() => {
                this.currentAppointment.closed = true;
              });
          });
        });
      },
      err => this.errorCallback(err)
    );
  }

  private errorCallback(error: any) {
    this.$log.error(error);
  }
}

export class PhoneAcceptingActions implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = [
    '$log',
    'contactDeprecatedService',
    'phoneActions',
    'agentConfigDeprecatedService',
    'sessionDeprecatedService',
    'appointmentDeprecatedService',
    PhoneAcceptingActionsCtrl,
  ];
}

export default 'contactPhoneAcceptingActions';
